import { IColumn } from '../type';
import { IConfigData } from '../../PageContainer/type';
import { resolveConfigFunction } from './resolveConfigFunction';

/**
 * 解析条件覆盖列，将满足条件的覆盖列合并到对应的 base 列上。
 *
 * 覆盖列通过 `overrideCode` 声明要覆盖哪个 base 列（对应 base 列的 `code`），
 * 通过 `overrideWhen(data)` 返回 `true` 时生效。
 *
 * @param columns - 原始列配置，包含 base 列和覆盖列
 * @param dataProps - CommonTable 的 data prop，供 overrideWhen 函数访问 filter 等上下文
 * @returns 合并后的列配置（不含覆盖列本身）
 */
export function resolveColumns(columns: IColumn[], dataProps: IConfigData | undefined): IColumn[] {
  const baseColumns = columns.filter((col) => !col.overrideCode);
  const overrideColumns = columns.filter((col) => col.overrideCode);

  if (!overrideColumns.length) {
    return baseColumns;
  }

  return baseColumns.map((col) => {
    const matched = overrideColumns.find((override) => {
      const overrideWhen = resolveConfigFunction(override.overrideWhen);
      return override.overrideCode === col.code && overrideWhen?.(dataProps);
    });
    if (!matched) {
      return col;
    }
    const overrideProps: Partial<IColumn> = Object.assign({}, matched);
    delete overrideProps.overrideWhen;
    delete overrideProps.overrideCode;
    return Object.assign({}, col, overrideProps);
  });
}
